var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { useLazyQuery } from '@apollo/client/react';
import { useMount } from 'react-use';
import { ChatMessageRole } from 'shared/domains/apollo/generated/types';
import { RequirementCheckedMessagesDocument } from './RequirementCheckedMessages.gql';
import { RequirementCheckedWorkflowDocument } from './RequirementCheckedWorkflow.gql';
import { zUserMessageSchema } from './schema';
export const useRequirementChecked = (documentChatId) => {
    const [requirementCheckedState, setRequirementCheckedState] = useState({ type: 'loading' });
    const [queryMessages] = useLazyQuery(RequirementCheckedMessagesDocument);
    const [queryPrompt] = useLazyQuery(RequirementCheckedWorkflowDocument);
    const fetchRequirementCheckedData = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        setRequirementCheckedState({ type: 'loading' });
        try {
            const { data } = yield queryMessages({ variables: { documentChatId } });
            const messages = (data === null || data === void 0 ? void 0 : data.documentChatsByUser[0].messages) || [];
            const userMessage = messages.find((message) => message.role === ChatMessageRole.User);
            const plaiMessage = messages.find((message) => message.role === ChatMessageRole.Assistant);
            const plaiResponse = (_a = plaiMessage === null || plaiMessage === void 0 ? void 0 : plaiMessage.content) !== null && _a !== void 0 ? _a : '';
            const additionalContext = (_b = userMessage === null || userMessage === void 0 ? void 0 : userMessage.content) !== null && _b !== void 0 ? _b : undefined;
            const { success, data: parsedUserMessage } = zUserMessageSchema.safeParse(userMessage);
            if (!success) {
                throw new Error();
            }
            const { workflowId } = parsedUserMessage.data;
            const { data: workflowData } = yield queryPrompt({ variables: { workflowId } });
            if (!((_c = workflowData === null || workflowData === void 0 ? void 0 : workflowData.workflow) === null || _c === void 0 ? void 0 : _c.activeVersion)) {
                throw new Error();
            }
            setRequirementCheckedState({
                type: 'finished',
                plaiResponse,
                additionalContext,
                workflowUsed: {
                    name: workflowData.workflow.name,
                    logic: workflowData.workflow.activeVersion.logic,
                },
            });
        }
        catch (_d) {
            setRequirementCheckedState({ type: 'error' });
        }
    });
    useMount(fetchRequirementCheckedData);
    return { requirementCheckedState };
};
